import { createNavigator } from "single-spa/react-app/router/utils/BaseNavigator";

import { ROUTES } from "./displayAdvertisingConstants";
import type { DisplayAdvertisingParamKeys } from "./displayAdvertisingRoutes.types";

// Only the navigable leaf states — container/root/frame/home are abstract
// and would throw at runtime if passed to .go()/.getLink().
const DISPLAY_ADVERTISING_NAVIGABLE_ROUTES = {
    overview: ROUTES.overview.stateName,
    campaigns: ROUTES.campaigns.stateName,
    ads: ROUTES.ads.stateName,
    adNetworks: ROUTES.adNetworks.stateName,
    publishers: ROUTES.publishers.stateName,
} as const;

export const displayAdvertisingNavigation = createNavigator<
    DisplayAdvertisingParamKeys,
    typeof DISPLAY_ADVERTISING_NAVIGABLE_ROUTES
>(DISPLAY_ADVERTISING_NAVIGABLE_ROUTES);
